import classNames from "classnames";
import { ClearIndicatorProps, components, GroupBase } from "react-select";

import { ReactComponent as Icon } from "./icons/clear.svg";

import styles from "./style.module.scss";

export function ClearIndicator<Option, IsMulti extends boolean, Group extends GroupBase<Option>>
({ className, children, ...props }: ClearIndicatorProps<Option, IsMulti, Group>) {
  return (
    <components.ClearIndicator {...props} className={classNames(className, styles.root)}>
      {children || <Icon />}
    </components.ClearIndicator>
  );
}